import { GetKitCombination } from '../../../../../../services/modules/kit/kitDetails/kitDetails.types';
import { KitCombinationTypes } from '../../../types/kit-combinations.types';
import { KitDetailsListGroup } from '../types/kitDetailsList.types';

const KIT_ITEMS_GROUP_KEY = 'kit-items';

const getKitCombinationGroupKey = (combination: GetKitCombination) => {
  if (combination.type !== KitCombinationTypes.CLOSED_KIT) {
    return KIT_ITEMS_GROUP_KEY;
  }

  return `closed-kit-${combination.orderId ?? 'no-order'}`;
};

export const mapKitDetailsListGroups = (combinations: GetKitCombination[]) => {
  const groups: KitDetailsListGroup[] = [];
  let currentKey: string | undefined;

  for (const combination of combinations) {
    const key = getKitCombinationGroupKey(combination);
    const currentGroup = groups[groups.length - 1];

    if (!currentGroup || key !== currentKey) {
      groups.push({ id: `${key}-${groups.length}`, count: 1, combination });
      currentKey = key;
      continue;
    }

    currentGroup.count += 1;
  }

  return groups;
};
